import { useCallback, useMemo, useState, useEffect } from 'react';
//@ts-expect-error untyped dependency
import { API_LIMIT } from '../../snowflake/report-options';
const DEFAULT_DRILLDOWN_LIMIT = 10;
const getDefaultLimit = isDrilldown => isDrilldown ? DEFAULT_DRILLDOWN_LIMIT : API_LIMIT;
const reportOptionsAreImmutable = options => {
  // @ts-expect-error Checking type based on presence of field
  return !!options.toJS;
};
const useJourneyReportOptions = (initialReportOptions, isDrilldown) => {
  const [limit, setLimit] = useState(getDefaultLimit(isDrilldown));
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    setLimit(getDefaultLimit(isDrilldown));
  }, [isDrilldown]);
  const handlePageChange = useCallback(nextPage => setOffset(limit * (nextPage - 1)), [limit, setOffset]);
  const handleLimitChange = useCallback(nextLimit => {
    setLimit(nextLimit);
    // Keep the offset divisible by the limit
    setOffset(offset - offset % nextLimit);
  }, [offset, setLimit, setOffset]);

  // TODO: Smarter memoization around the rest of initialReportOptions fields
  return useMemo(() => {
    const plainObjectInitialReportOptions = reportOptionsAreImmutable(initialReportOptions) ? initialReportOptions.toJS() : initialReportOptions;
    return {
      reportOptions: Object.assign({}, plainObjectInitialReportOptions, {
        limit,
        offset
      }),
      handlePageChange,
      handleLimitChange
    };
  }, [initialReportOptions, limit, offset, handlePageChange, handleLimitChange]);
};
export default useJourneyReportOptions;